export default {
  name: 'MinutesToText',
  props: {
    minutes: {
      type: Number | String
    },
    short: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    minutesToText: function (duration) {
      const text = [];
      const minutes = duration % 60;
      const hours = parseInt(duration / 60) % 24;
      const days = parseInt((duration / 24) / 60);

      if (days > 0) {
        text.push(days + ' ' + (this.short ? 'd' : (days > 1 ? this.$t('shift.times.days') : this.$t('shift.times.day'))));
      }

      if (hours > 0) {
        text.push(hours + ' ' + (this.short ? 'h' : (hours > 1 ? this.$t('shift.times.hours') : this.$t('shift.times.hour'))));
      }

      if (minutes > 0) {
        text.push(minutes + ' ' + (this.short ? 'm' : (minutes > 1 ? this.$t('shift.times.minutes') : this.$t('shift.times.minute'))));
      }

      return text.join(', ');
    }
  }
}
